export const locale = {
    lang: 'ds',
    data: {
        'BUTTONS': {
            'CoworkerAssign': 'Tildel medarbejder',
            'Cancel': 'Annulerer',
        },
    }
};